define('modules/reporting/campaigns/geoPerformance/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  return ColumnSortable.extend({});
});
